import { Chip } from '@components/std-components/Chip'
import ColorCircle from '@components/UI-Components/ChipList/ColorCircle'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import classNames from 'classnames'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import ChipListSkeleton from '@modules/order/components/CellLoaders/ChipListSkeleton/ChipListSkeleton'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  clusterContainer: {
    height: 240,
    margin: '16px 0px',
    padding: '0px 12px',
    overflowX: 'hidden',
    overflowY: 'auto'
  },
  chip: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '110px',
    margin: '0px 0px 10px',
    height: '24px',
    padding: '0',
    position: 'relative',
    borderRadius: '12px'
  },
  clusterColor: {
    position: 'absolute',
    left: '7px',
    marginRight: '5px'
  },
  content: {
    left: '22px',
    position: 'absolute',
    maxWidth: 'calc(100% - 22px)'
  }
}))

const getCMClusters = rowData => {
  const cmClusters = rowData?.['retailClusters-id']?.map((id, index) => {
    return {
      id,
      name: rowData?.['retailClusters-name']?.[index],
      color: rowData?.['retailClusters-color']?.[index],
      status: rowData?.['retailClusters-status']?.[index]
    }
  })
  return cmClusters
}

const EnhancedCMClusters: FC<CellItem> = ({ rowData }) =>
  useObserver(function useHook() {
    const classes = useStyles()
    if (!rowData) {
      return (
        <div>
          <ChipListSkeleton count={3} />
        </div>
      )
    }
    return (
      <div className={classes.clusterContainer}>
        {getCMClusters(rowData)?.map(({ id, name, color, status }) => (
          <Chip
            className={classes['chip']}
            key={id}
            offset={{ bottom: 12 }}
            tooltip={`${name}${status ? `: ${status}` : ''}`}
          >
            <div className={classes.clusterColor}>
              <ColorCircle color={color} />
            </div>
            <Typography
              variant='captionDarkGrey'
              className={classNames(classes.content, 'text-ellipsis')}
            >
              {name}
              {status ? `: ${status}` : ''}
            </Typography>
          </Chip>
        ))}
      </div>
    )
  })

export default EnhancedCMClusters
